export default {
	error1: 'Errores de nombre/Apellido',
	error2: 'Por favor lea y consienta al acuerdo y la política de privacidad',
	error3: 'Por favor ingrese su número de teléfono',
	error4: 'Por favor Chequee el correo',
	error5: 'Por facor selecione el curso donde está y asignatura',
	error6: 'Error de sistema. Pruébelo de nuevo',
	firstName: 'Nombre',
	yFirstName: 'Su nombre',
	lastName: 'Apellido',
	yLastName: 'Su apellido',
	grade: 'Curso',
	yGrade: 'Su curso',
	search: 'Buscar',
	subject: 'Asignaturas o Idiomas',
	ySubject: 'Su asignatura/idioma',
	consentTo: 'Consentir a ',
	requestNow: '¡Reservar Clase Gratis!',
	searchText: 'Seleccione País o Región',
	pcImg: 'https://web-data.zmlearn.com/image/fatk6XkgntWWSwUUUtHXfR/pc_es_popup.png',
	phoneImg: 'https://web-data.zmlearn.com/image/fKFGpSLknkKFxQtydzWPcY/m_es_popup_bg.png',
	title: 'Reservar una clase de prueba Por gratis',
	agreeToReceive: 'Me gustaría recibir consejos, novedades y ofertas de AirClass (emails y SMS)',
	disagreePrompt: 'Debe aceptar nuestros términos antes de registrarse',
};
